import React from "react";
import ScrollableAnchor from "react-scrollable-anchor";
import {
  Heading1,
  Heading2,
  Heading3,
  Paragraph,
  LinkStyled,
  Hr,
  Bold,
  Span,
  List,
} from "../components/typography";
import { Image } from "../components/Image";
import { Container, Row, Col } from "../components/grid";
import { Table, Th, Td } from "../components/tables";
import { MomsChange, Price } from "../containers/commerce";
import SidemenuLayout from "../layout/DefaultLayout/Layouts/SidemenuLayout";

export default () => (
  <SidemenuLayout menuPicker="Infosider" activeSidemenu="PantReturregler">
    <Container white>
      <Row>
        <Col xs={3} textCenter>
          <Paragraph>
            <Image
              name="retursystem.retursystem-skafte.jpg"
              alt="Retusystem - Peter Skafte"
            />
            <br />
            <Span fontSize="12px">
              Flasker og retursække afhentes i forbindelse med levering af
              friske drikkevarer
            </Span>
          </Paragraph>
        </Col>
        <Col xs={9}>
          <Heading1>
            Pant- og returregler
            <br /> ved leverancer fra Peter Skafte
          </Heading1>
          <Paragraph>
            Alt hvad vi leverer i genpåfyldelige flasker (flasker beregnet til
            returnering til producenten for vask og genfyldning), tager vi også
            retur. Genpåfyldelige flasker kendetegnes ved at de altid leveres i
            en plastikkasse.
          </Paragraph>
          <Paragraph>
            Kreditering/modregning foretages direkte på fakturaen med de
            leverede drikkevarer. Ved bestillingen er det unødvendigt at oplyse
            hvor mange kasser og flasker der ønskes taget retur. Vi medtager
            automatisk det hele.
          </Paragraph>
          <Paragraph>
            Nye kunders returkasser fra tidligere leverandører medtages gerne i
            forbindelse med leverancer fra os.
          </Paragraph>
          <Paragraph>
            Alt hvad vi leverer af engangs plastflasker, glasflasker og dåser
            med dansk A, B eller C pantmærke skal i sække og retur til
            Dansk-Retursystem.
          </Paragraph>
          <Paragraph>
            I forbindelse med levering af sodavand, kildevand og øl, kan vi
            efter særlig aftale medtage sække med engangsembalage til Dansk
            Retursystem. Disse sække sørger vi for at aflevere til
            Dansk-Retursystem i vores kundes navn.
          </Paragraph>
          <Paragraph>
            Har du betalt online med betalingskort, hæver vi først beløbet efter
            leveringen, modregnet eventuel returpant.
          </Paragraph>
        </Col>
      </Row>
      <Hr />
      <Row>
        <Col xs={3} textCenter>
          <Paragraph>
            <Image
              maxHeight="500px"
              name="retursystem.retursystem-pose-qr.png"
              alt="Retursystem - pose med fyld"
            />
            <br />
            <Span fontSize="14px">Sæk med pant</Span>.<br />
            <Span fontSize="14px" blue bold>
              Husk at scanne QR koden inden du afleverer sækken!
            </Span>
          </Paragraph>
          <Paragraph>
            <Image
              maxHeight="250px"
              imageHeight="250px"
              name="retursystem.strip-hvid.png"
              alt="Retursystem - strip"
            />
            <br />
            <Span fontSize="14px">Hvid strips til lukning</Span>
          </Paragraph>
          <Paragraph>
            <Image
              maxHeight="250px"
              imageHeight="250px"
              name="retursystem.retursystem-holder.png"
              alt="Retursystem - spand"
            />
            <br />
            <Span fontSize="14px">
              Holder til retursæk. Sælges/bestilles ikke hos Skafte Øl &amp;
              Vand, men direkte hos Dansk Retursystem.
            </Span>
          </Paragraph>
          <Paragraph>
            <Image
              maxHeight="250px"
              imageHeight="250px"
              name="retursystem.retursystem-pose150x129.jpg"
              alt="Retusystem - pose"
            />
            <br />
            <Span fontSize="14px">Rulle med retursække</Span>
          </Paragraph>
        </Col>
        <Col xs={9}>
          <Heading2>
            Dansk Retursystem A/S{" "}
            <Span fontSize="12px">Et privat non-profit selskab</Span>
          </Heading2>
          <Heading3>
            Gratis afhentning og refundering af pant på engangsflasker og dåser.
          </Heading3>
          <Paragraph>
            <Bold>Siden år 2000</Bold> har Dansk Retursystem haft eneret på
            indsamling af pantbelagte engangsdåser og -flasker til øl og
            læskedrikke.
          </Paragraph>
          <Paragraph>
            <Bold>Det er helt gratis -</Bold> vi anbefaler alle kunder straks at
            tilmelde sig Dansk Retursystem og få de tomme engangsflasker og
            dåser (med dansk pantmærke) afhentet på adressen.
          </Paragraph>
          <Paragraph>
            <Bold>Udenom retursystemet -</Bold> kan kunder selv indløse
            engangsemballagerne i enhver dagligvarebutik med returautomat.
          </Paragraph>
          <Paragraph>
            <Bold>Yderligere information -</Bold> om retursystemet kan findes
            her:{" "}
            <LinkStyled
              external
              title="Dansk-Retursystems hjemmeside. Alt om pant på engangsemballage"
              to="http://www.dansk-retursystem.dk"
            >
              Dansk-Retursystems hjemmeside
            </LinkStyled>
            .
          </Paragraph>
          <Paragraph>
            <Bold>Tilmelding -</Bold> kan findes på{" "}
            <LinkStyled
              external
              title="Direkte link til tilmelding til afhentning af engangsembalager"
              to="https://danskretursystem.dk/for-virksomhed/tilmeld/"
            >
              Dansk-Retursystems hjemmeside
            </LinkStyled>
            .
          </Paragraph>
          <Paragraph>
            <Bold>Kvit og frit - </Bold>bestilles herefter afhentning af de
            tomme engangsemballager. (Mindst 5 sække pr. afhentning)
          </Paragraph>
          <Paragraph>
            <Bold>Afregning - </Bold> tilgår den enkelte kundes bankkonto
            direkte.
          </Paragraph>
          <Paragraph>
            <Bold>Specielle sække - </Bold> samt lukkestrips til formålet
            bestilles hos Dansk Retursystem.
          </Paragraph>
          <Paragraph>
            <Bold>Ophængningsstativ - </Bold>til de specielle sække hvori den
            tomme emballage skal samles, kan fås hos Dansk Retursystem, leveret
            imod depositum kr. 500,-
          </Paragraph>
          <Paragraph>
            <Bold>I samme s&aelig;k -</Bold> Du kan samle d&aring;ser af
            aluminium og flasker af plastik i samme s&aelig;k. Glas skal i
            mindre sække for sig selv.
          </Paragraph>
          <Paragraph>
            <Bold>Låg og indhold - </Bold> Det er uden betydning for
            pantafregningen, om der er låg på eller ej. Af hensyn til sækkenes
            vægt må emballagerne ikke indholde væske.
          </Paragraph>
          <Paragraph>
            <Bold>Emballager med defekt returmærke - </Bold> refunderes ikke,
            men ellers er det uden betydning om emballagen er intakt.
          </Paragraph>
          <Paragraph>
            <Bold>Sækkene skal fyldes - </Bold> Hver sæk rummer cirka 300 dåser
            eller 200 halvliters plastflasker eller 50 glasflasker. Det er et
            krav, at sækkene fyldes 90-100 procent.
          </Paragraph>
          <Paragraph>
            <Bold>Gebyr - </Bold>pålægges ved underfyldning af sække og
            fratrækkes pantgodtgørelsen.
          </Paragraph>
          <Paragraph>
            <Bold>Sækkene afhentes -</Bold> i fast turnus eller på bestilling.
            Det er et krav, at der mindst skal være 5 sække pr. afhentning.
          </Paragraph>
          <Paragraph bold blue uppercase fontSize="20px">
            Registrering af sække
          </Paragraph>
          <Paragraph>
            <Bold>Hver sæk er påtrykt med en unik QR kode</Bold>.{" "}
            <Span bold underline blue>
              Det er meget vigtigt at kunden registrerer posen i deres app
            </Span>{" "}
            fra Dansk Retursystem inden vi henter pantsækkene. Indholdet
            optælles maskinelt og afregningen sker automatisk direkte til
            kundens egen bankkonto hver 4. uge.
          </Paragraph>
          <Paragraph>
            Er sækken ikke scannet med appen bliver der ikke udbetalt pant.
          </Paragraph>
          <Paragraph>
            Mindre kunder - kan aflevere originale Dansk-Retursystem sække til
            os, så sørger vi for videre ekspedition til optællings centralen.
          </Paragraph>
          <Paragraph>
            Husk at I selv skal scanne sækkene med Dansk Retursystem appen inden
            vi afhenter dem.
          </Paragraph>
        </Col>
      </Row>
      <Hr />
      <Row>
        <Col xs={3} textCenter>
          <Paragraph>
            <Image
              maxHeight="300px"
              name="retursystem.standard-oelflaske.jpg"
              alt="Standard genpåfyldelig ølflaske uden pantmærke (det skal den ikke have)"
            />
            <br />
            <Span fontSize="12px">Standard returflaske</Span>
          </Paragraph>
          <Paragraph>
            <Image
              name="retursystem.PantA.gif"
              alt="Pantmærke A værdi 1,00 indlæses af Dansk-Retursystem"
            />{" "}
            = kr. 1,00
          </Paragraph>
          <Paragraph>
            <Image
              name="retursystem.PantB.gif"
              alt="Pantmærke B værdi 1,50 indlæses af Dansk-Retursystem"
            />{" "}
            = kr. 1,50
          </Paragraph>
          <Paragraph>
            <Image
              name="retursystem.PantC.gif"
              alt="Pantmærke C værdi 3,00 indlæses af Dansk-Retursystem"
            />{" "}
            = kr. 3,00
          </Paragraph>
          <Paragraph fontSize="12px">Panten er med moms</Paragraph>
        </Col>
        <Col xs={9}>
          <Heading2>
            Lovmæssig pant på alle flasker og dåser til øl og læskedrikke:
          </Heading2>
          <Paragraph>
            Det er lovmæssigt bestemt at der skal være pant på alle flasker og
            dåser til:
          </Paragraph>
          <List>
            <li>Øl</li>
            <li>
              Sodavand <Span fontSize="12px">Kulsyreholdig mineralvand</Span>
            </li>
            <li>Alkoholsodavand</li>
            <li>
              Kildevand <Span fontSize="12px">Limonade og iste</Span>
            </li>
            <li>Fra november 2019: Juice &amp; saft</li>
          </List>
          <Paragraph>
            Der skal ikke være pant på kartoner med ovenstående indhold.
          </Paragraph>
          <Paragraph>
            I modsætning til engangsemballager der skal være påtrykt det danske
            pantmærke A, B eller C, er der ikke noget mærke eller tekst på
            genbrugsflaskerne der oplyser om pantværdien.
          </Paragraph>
          <Heading2>Pantsatser:</Heading2>
          <Table lines1 margin="15px 0">
            <thead>
              <tr>
                <Th>
                  Returflasker, flasker beregnet til vask og genopfyldning
                </Th>
                <Th textRight>Pant med moms</Th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <Td>Glasflasker til og med 50 cl</Td>
                <Td textRight>1,00 kr.</Td>
              </tr>
              <tr>
                <Td>Glasflasker over 50 cl</Td>
                <Td textRight>3,00 kr.</Td>
              </tr>
              <tr>
                <Td>Plastflasker under 100 cl</Td>
                <Td textRight>1,50 kr.</Td>
              </tr>
              <tr>
                <Td>Plastflasker fra og med 100 cl</Td>
                <Td textRight>3,00 kr.</Td>
              </tr>
            </tbody>
          </Table>
          <Table lines1 margin="15px 0">
            <thead>
              <tr>
                <Th>Engangsemballage</Th>
                <Th textRight>Pant med moms</Th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <Td>Dåser og glasflasker under 100 cl</Td>
                <Td textRight>A = 1,00 kr.</Td>
              </tr>
              <tr>
                <Td>Plastflasker under 100 cl</Td>
                <Td textRight>B = 1,50 kr.</Td>
              </tr>
              <tr>
                <Td>Dåser, glasflasker og plastflasker fra og med 100 cl</Td>
                <Td textRight>C = 3,00 kr.</Td>
              </tr>
            </tbody>
          </Table>
          <Table lines1 margin="15px 0">
            <thead>
              <tr>
                <Th>Plastkasser til returflasker</Th>
                <Th textRight>Pant med moms</Th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <Td>Plastkasser til øl eller læskedrikke</Td>
                <Td textRight>12,50 kr.</Td>
              </tr>
              <tr>
                <Td>Plastkasser til visse specielle produkter</Td>
                <Td textRight>25,00 kr.</Td>
              </tr>
            </tbody>
          </Table>
        </Col>
      </Row>
      <Hr />
      <ScrollableAnchor id="pant-fustager">
        <div>
          <Row>
            <Col xs={3} textCenter>
              <Row>
                <Col xs={12} sm={6}>
                  <Image
                    name="retursystem.3615-kasse.png"
                    title="Carlsberg fustage"
                    maxHeight="150px"
                    imageHeight="150px"
                  />
                  <Paragraph fontSize="12px" marginTop="12px">
                    Carlsberg/Tuborg
                  </Paragraph>
                </Col>
                <Col xs={12} sm={6}>
                  <Image
                    name="retursystem.8345-kasse.png"
                    title="Vestfyen fustage"
                    maxHeight="150px"
                    imageHeight="150px"
                  />
                  <Paragraph fontSize="12px" marginTop="12px">
                    Ale 16
                  </Paragraph>
                </Col>
              </Row>
              <Row>
                <Col xs={12} sm={6}>
                  <Image
                    name="retursystem.royal-fustage.png"
                    title="Royal fustage"
                    maxHeight="150px"
                    imageHeight="150px"
                  />
                  <Paragraph fontSize="12px" marginTop="12px">
                    Royal
                  </Paragraph>
                </Col>
                <Col xs={12} sm={6}>
                  <Image
                    name="retursystem.platan-fustage.png"
                    title="Platan fustage"
                    maxHeight="150px"
                    imageHeight="150px"
                  />
                  <Paragraph fontSize="12px" marginTop="12px">
                    Platan
                  </Paragraph>
                </Col>
              </Row>
              <Row>
                <Col xs={12} sm={6}>
                  <Image
                    name="produkter-fadoel.hancock-fustage.png"
                    title="Hancock fustage"
                    maxHeight="150px"
                    imageHeight="150px"
                  />
                  <Paragraph fontSize="12px" marginTop="12px">
                    Hancock
                  </Paragraph>
                </Col>
                <Col xs={12} sm={6}>
                  <Image
                    name="returpant.modular20-pant.png"
                    title="Modular 20 pant"
                    maxHeight="150px"
                    imageHeight="150px"
                  />
                  <Paragraph fontSize="12px" marginTop="12px">
                    MD20
                  </Paragraph>
                </Col>
              </Row>
            </Col>
            <Col xs={9}>
              <ScrollableAnchor id="pant-fustager">
                <div>
                  <Heading2>Pant på ølfustager:</Heading2>
                  <Paragraph>
                    Ligesom på øl og sodavandsflasker, er der pant på
                    metaltønden som fadøl leveres i.
                  </Paragraph>
                  <Paragraph>
                    Panten på ølfustager er ikke lovmæssigt reguleret. Panten
                    fastsættes af det enkelte bryggeri, med udgangspunkt i
                    tradition og fustagernes anskaffelsespris.
                  </Paragraph>
                  <Paragraph>
                    Pant opkræves for at sikre at fustagerne hurtigst muligt
                    vender tilbage til bryggeriet til vask og genopfyldning. En
                    ny fustage koster ca. 400,00 kr. + moms, når nogen
                    bryggerier tager en lavere pant end indkøbsprisen, skyldes
                    det at de ikke har reguleret panten op i lang tid og at de
                    muligvis har en så stor beholdning af fustager, at det er
                    længe siden de har købt nye.
                  </Paragraph>
                  <Table lines1 margin="15px 0">
                    <thead>
                      <tr>
                        <Th>Følgende bryggerier tager følgende pantpriser</Th>
                        <Th textRight>
                          Pant <MomsChange />
                        </Th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <Td>Modular 20 plastikfustage</Td>
                        <Td textRight>
                          <Price embPrice varenr="3675" />
                        </Td>
                      </tr>
                      <tr>
                        <Td>
                          Carlsberg / Tuborg / Royal / Albani / Hancock /
                          Wiibroe / Thor / Jacobsen / Ale no. 16 / Nørrebro /
                          Anarkist
                        </Td>
                        <Td textRight>
                          <Price embPrice varenr="2615" />
                        </Td>
                      </tr>
                      <tr>
                        <Td>
                          Heineken / Newcastle / Edelweiss / Kilkenny / Guinness
                          / Depot Pilsner / Grimbergen / Kronenbourg / Brooklyn
                        </Td>
                        <Td textRight>
                          <Price embPrice varenr="4915" />
                        </Td>
                      </tr>
                      <tr>
                        <Td>Platan / Skovlyst</Td>
                        <Td textRight>
                          <Price embPrice varenr="8415" />
                        </Td>
                      </tr>
                      <tr>
                        <Td>
                          Paulaner / Hoegaarden / Fransizkaner / Staropramen /
                          Leffe
                        </Td>
                        <Td textRight>
                          <Price embPrice varenr="23785" />
                        </Td>
                      </tr>
                      <tr>
                        <Td>Svaneke Bryghus</Td>
                        <Td textRight>
                          <Price embPrice varenr="19655" />
                        </Td>
                      </tr>
                      <tr>
                        <Td>
                          Nørrebro Bryghus (gammel model - lav og tyk) / Herslev
                          Bryghus
                        </Td>
                        <Td textRight>
                          <Price embPrice varenr="8055" />
                        </Td>
                      </tr>
                    </tbody>
                  </Table>
                  <Paragraph>
                    For fustager købt hos os, udbetaler vi altid fuld pant ved
                    returnering. Har du ikke købt fustagerne hos os, tager vi
                    gerne imod din fustage, men i dette tilfælde fratrækkes 100
                    kr. pr. fustage
                  </Paragraph>
                </div>
              </ScrollableAnchor>
            </Col>
          </Row>
        </div>
      </ScrollableAnchor>
      <Hr />
      <Row>
        <Col xs={3} textCenter>
          <Row>
            <Col xs={12} sm={6}>
              <Image
                name="kulsyre.4-kg-kulsyreflaske-roed.png"
                title="4kg kulsyreflaske rød"
                maxHeight="150px"
                imageHeight="150px"
              />
              <Image
                name="kulsyre.6-kg-kulsyreflaske-roed.png"
                title="4kg kulsyreflaske rød"
                maxHeight="170px"
                imageHeight="170px"
              />
            </Col>
            <Col xs={12} sm={6}>
              <Image
                name="kulsyre.4-kg-kulsyreflaske-groen.png"
                title="4kg kulsyreflaske rød"
                maxHeight="150px"
                imageHeight="150px"
              />
              <Image
                name="kulsyre.6-kg-kulsyreflaske-groen.png"
                title="4kg kulsyreflaske rød"
                maxHeight="170px"
                imageHeight="170px"
              />
            </Col>
          </Row>
        </Col>
        <Col xs={9}>
          <Heading2>Pant på kulsyre:</Heading2>
          <Paragraph>
            Vi lagerfører to størrelser af kulsyreflasker - 4kg. og 6kg.
          </Paragraph>
          <Paragraph>
            På flasker med røde ventilhåndtag er panten{" "}
            <Price varenr="8944" embPrice momsIndication />.<br />
            På flasker med grønne ventilhåndtag er panten{" "}
            <Price varenr="870" embPrice momsIndication />.
          </Paragraph>
        </Col>
      </Row>
    </Container>
  </SidemenuLayout>
);
